module.exports = __webpack_public_path__ + "static/media/harvardLogo.83a05b10.png";